import { merchantIcons } from '@assets/icons';
import { memo } from 'react';

const BusinessResultItem = memo(({ name, address, onSelect }) => (
  <button
    type="button"
    onClick={onSelect}
    className="flex w-full cursor-pointer items-center gap-business-result-row py-0 text-left transition-opacity hover:opacity-70"
  >
    <span className="flex min-w-0 flex-1 flex-col gap-business-result-row">
      <span className="desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-primary">
        {name}
      </span>
      <span className="text-sm font-normal text-merchant-text-secondary">{address}</span>
    </span>
    <img
      src={merchantIcons.arrowRight}
      alt=""
      className="icon-md shrink-0 opacity-90"
      aria-hidden="true"
    />
  </button>
));

BusinessResultItem.displayName = 'BusinessResultItem';

export default BusinessResultItem;
